export const UserResetPass = {
	url: '/resetpassword',
	title: 'Reset Password',
	template: '<change-pass-page></change-pass-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "changePasswordPageMod" */
			'@Containers/user-change-pass-page/change-pass-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
